import React from 'react';
import { SettingsIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
const AUTHOR_PHOTO = 'https://cdn.magicpatterns.com/patterns/generated-images/ba41f114-1a5d-42c6-902d-32f6ca516aaf.jpg';
export function Mission() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:py-20" data-id="element-200" data-mp="2wefa264zao6b">
      <div className="mx-auto max-w-3xl" data-id="element-201" data-mp="30e7nox98bkij">
        <p className="flex items-center justify-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-arc-400" data-id="element-202" data-mp="30d4weo7zvg23">
          <SettingsIcon className="h-4 w-4" aria-hidden="true" data-id="element-203" data-mp="28ntdbb0fcqbm" />
          Notre mission
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-204" data-mp="2cpwqc42qs2z0">
          Pourquoi avons-nous créé le Système Maître de Soudage™ ?
        </h2>

        <div className="mt-8 grid gap-6 md:grid-cols-[minmax(0,260px)_1fr] md:items-start" data-id="element-205" data-mp="1kza66yt42jl4">
          <figure className="mx-auto w-full max-w-[260px]" data-id="element-206" data-mp="1ozkfolg43s4q">
            <img src={AUTHOR_PHOTO} alt="Carlos Ramírez, instructeur en soudage et créateur du Système Maître de Soudage™" className="w-full rounded-2xl border border-white/10 object-cover" data-id="element-207" data-mp="1oxpquw1pzfvd" />
            <figcaption className="mt-3 text-center md:text-left" data-id="element-208" data-mp="3bohjzy9bbz1w">
              <p className="text-base font-extrabold text-white" data-id="element-209" data-mp="36q66ndjt76ex">Carlos Ramírez</p>
              <p className="text-xs text-white/55" data-id="element-210" data-mp="36obwmua2sypm">
                Instructeur en soudage · 18 ans d’atelier
              </p>
            </figcaption>
          </figure>

          <div className="space-y-4 text-[15px] leading-relaxed text-white/70" data-id="element-211" data-mp="2xnwyguc0jp4p">
            <p data-id="element-212" data-mp="2srg7zthccyog">
              Parce que la plupart des personnes n’échouent pas en soudage par manque de
              capacité.
            </p>
            <p className="font-bold text-white" data-id="element-213" data-mp="2ntn4x9bc4kse">
              Elles échouent parce que personne ne leur a expliqué clairement quoi faire
              avant d’allumer la machine.
            </p>
            <p data-id="element-214" data-mp="lxuppgezhxbe">
              Elles apprennent en regardant des vidéos qui se contredisent. Elles gaspillent
              du matériau en faisant des essais. Et elles finissent par croire que la
              soudure est beaucoup plus difficile qu’elle ne l’est réellement.
            </p>
            <p className="border-l-4 border-spark-500 pl-4 font-bold text-spark-400" data-id="element-215" data-mp="26jswjrj8tfjw">
              Le Système Maître de Soudage™ a été créé pour changer cela.
            </p>
            <p data-id="element-216" data-mp="2z7ykso9i9moh">
              Ce n’est pas une autre formation remplie de théorie. C’est un guide de
              référence pratique conçu pour vous dire exactement quoi faire chaque fois que
              vous allez souder.
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-217" data-mp="2u711u9go8olx">
          <CtaBlock label="Commencer avec le système" data-id="element-218" data-mp="2u5zfv9y4ahpf" />
        </div>
      </div>
    </section>;
}